import { useMemo } from 'react';
import I18n from 'I18n';
import { getFieldSections } from 'reporting-snowflake/relational/utils/field-utils';
import { getReportFieldRefs } from 'reporting-snowflake/relational/utils/report-utils';
import { sortOptionsByText } from 'reporting-snowflake/shared/lib/utils';
import useFetchUserInfo from '../useFetchUserInfo';
export const useProperties = ({
  relationalReport,
  allJoinMetadata,
  fullTableAndPropertyMeta
}) => {
  var _userInfo$gates, _userInfo$user;
  const tableDescription = relationalReport.table;
  const userInfo = useFetchUserInfo();
  const hasFlexibleAssociationsAccess = Boolean((userInfo === null || userInfo === void 0 || (_userInfo$gates = userInfo.gates) === null || _userInfo$gates === void 0 ? void 0 : _userInfo$gates.includes('flexible-associations')) && (userInfo === null || userInfo === void 0 || (_userInfo$user = userInfo.user) === null || _userInfo$user === void 0 || (_userInfo$user = _userInfo$user.scopes) === null || _userInfo$user === void 0 ? void 0 : _userInfo$user.includes('custom-association-labels')));
  const reportFieldRefs = getReportFieldRefs(relationalReport);
  const fieldSections = useMemo(() => {
    if (!fullTableAndPropertyMeta.data || !allJoinMetadata) {
      return {
        isPropertiesLoading: true,
        standardProperties: []
      };
    }
    const {
      data: {
        tables,
        properties
      }
    } = fullTableAndPropertyMeta;
    const sectionsMap = getFieldSections({
      tableDescription,
      properties,
      tables,
      allJoinMetadata,
      reportFieldRefs,
      hasFlexibleAssociationsAccess
    });
    if (sectionsMap.size === 1 && sectionsMap.has('')) {
      return {
        isPropertiesLoading: true,
        standardProperties: []
      };
    }
    const propertiesResult = sectionsMap.reduce((accumulator, propertyGroup) => {
      if (!propertyGroup || propertyGroup.fields.length === 0) {
        return accumulator;
      }
      const fields = propertyGroup.fields;
      if (fields.length > 0) {
        accumulator.push({
          text: propertyGroup.heading.text,
          value: propertyGroup.heading.text,
          options: fields.map(field => ({
            text: field.text,
            value: `${field.value.table}.${field.value.name}`,
            disabled: Boolean(field.errorMessage || field.warningMessage),
            help: field.errorMessage || field.warningMessage ? I18n.text('report-customization-components.customization-components.relational-report.default-measures-help') : undefined
          })).sort(sortOptionsByText)
        });
      }
      return accumulator;
    }, []);
    return {
      isPropertiesLoading: false,
      standardProperties: propertiesResult
    };
  }, [allJoinMetadata, fullTableAndPropertyMeta, hasFlexibleAssociationsAccess, tableDescription, reportFieldRefs]);
  return fieldSections;
};